import Styles from "./Success.module.css";
import success from "../../../Assets/customer_success.png";
import Header from "../../../SharedComponents/Header/Header";
import { useEffect, useState } from "react";
import SupportContactModal from "../../../Modal/SupportContactModal";

export default function Success() {
  const isproduct = sessionStorage.getItem("isproduct");
  const mobileNumber = sessionStorage.getItem("franchise_mobile");
  const [showSupportListModal, setshowSupportListModal] = useState(false);

  useEffect(() => {
    sessionStorage.setItem("isproduct", false);
  }, [isproduct]);

  return (
    <>
      <Header />
      <div className={Styles.overallContainer + " container-fluid p-0"}>
        <div className={Styles.childContainer}>
          <img className={Styles.img} src={success} alt="success" />
          <p className={Styles.success}>Thanks for shopping with us!!!</p>
          {mobileNumber && (
            <p className={Styles.note}>
              For more details call or WhatsApp{" "}
              <button
                type="button"
                className={Styles.phoneBtn}
                onClick={() => setshowSupportListModal(true)}
              >
                {mobileNumber}
              </button>
            </p>
          )}
        </div>
      </div>
      <SupportContactModal
        show={showSupportListModal}
        onClose={() => setshowSupportListModal(false)}
        phone={mobileNumber}
      />
    </>
  );
}
